/** Edits a simple TravelRequest. To generate a request from a response, see `./offerResponseToRequest.js`
 * This is a bound component - it does not store the edited request in its own stat, but relies on
 * the 'request' and 'onRequestChange' props entirely. */

import React from 'react'
import PropTypes from 'prop-types'
import ImmutablePropTypes from 'react-immutable-proptypes'
import { List, Map } from 'immutable'
import moment from 'moment'
import { withProps } from 'recompose'
import DatePicker from 'react-16-bootstrap-date-picker'
import LocationInput from './LocationInput'

const AccommodationRequirementEditor = ({
    request = List(),
    // Request update functionality
    checkinDateChange,
    checkoutDateChange,
    locationChange,
    numOfRoomsChange,
    addHotel,
    remHotel
  }) =>
    <div className="container trip-request-form hotels-request-form">
      <div className="travel-info hotels-info">
        <div className="hotels-rows">
          <a style={{cursor:"pointer"}} className="add-btn-link" onClick={addHotel}>
              <i className="plus-btn"></i><span>Add another hotel</span>
          </a>
          {request.get('required', List()).map((r = Map(), i) =>
            {
              if (!r.get("checkIn"))
              {
                r = r.set("checkIn", moment().format("YYYY-MM-DD"))
              }
              if (!r.get("checkOut"))
              {
                r = r.set("checkOut", moment().add(1, 'days').format("YYYY-MM-DD"))
              }
            return <div className="row form-row" key={i}>
              <div className="col-xs-24 leg-header">
                  <h3>{i + 1}</h3>
                  { request.get('required', List()).size > 1 &&
                      <a
                          onClick={remHotel(i)}
                          style={{cursor:"pointer"}} className="del-btn" title="Delete hotel">&nbsp;</a>
                  }
              </div>
              <div className="col-xs-24 col-sm-24 col-md-8">
                <div className="col-wrapper-va">
                  <LocationInput placeholder="Location" className="pic pic-location" onChange={locationChange(i)}
                  location = {r.get('approximateLocation', null)} />

                  {/*<input placeholder="To" value={r.getIn(['approximateLocation','address','region'], null)===null?`London`:r.getIn(['approximateLocation','address','region'])} className="pic pic-location" type="text" onChange={locationChange(i)}/>*/}
                </div>
              </div>
              <div className="col-xs-24 col-sm-12 col-md-5">
                <div className="col-wrapper-va">
                  {/*<input placeholder="Check-in" className="pic pic-date" value="" type="text"/>*/}
                  <DatePicker
                      id={`checkinDate`}
                      dateFormat="YYYY-MM-DD"
                      value={moment(r.get('checkIn')).format('YYYY-MM-DD')}
                      minDate={moment().format()}
                      onChange={checkinDateChange(i)}
                      showClearButton={true}
                      />
                </div>
              </div>
              <div className="col-xs-24 col-sm-12 col-md-5">
                <div className="col-wrapper-va">
                  {/*
                    <input placeholder="Check-out" className="pic pic-date" value="" type="text"/>
                    */}
                  <DatePicker
                      id={`checkoutDate`}
                      dateFormat="YYYY-MM-DD"
                      value={moment(r.get('checkOut')).format('YYYY-MM-DD')}
                      minDate={moment(r.get("checkIn")).format()}
                      onChange={checkoutDateChange(i)}
                      showClearButton={true}
                      />
                </div>
              </div>
              <div className="col-xs-24 col-sm-24 col-md-6">
                <div className="col-wrapper-va">
                  <select name="travel-reason" onChange={numOfRoomsChange(i)} value={r.get('totalUnitsRequired')}>
                    <option value="">- Number of Rooms -</option>
                    <option value="1">1 Room</option>
                    <option value="2">2 Rooms</option>
                    <option value="3">3 Rooms</option>
                    <option value="4">4 Rooms</option>
                    <option value="5">5 Rooms</option>
                  </select>
                </div>
              </div>
            </div>
            }
          )}
        </div>
      </div>
    </div>

AccommodationRequirementEditor.propTypes = {
    // The travel request to display / edit
    request: ImmutablePropTypes.map,
    // Called if user makes any changes to request. TravelRequest -> ()
    onRequestChange: PropTypes.func.isRequired
}

/** Constructs the fine-grained editing functions that the UI needs, and maps them
 * to higher-level 'on change' callback.
 */
const fineGrainedEditCallbacks = ({ request = Map(), onRequestChange }) => ({
  // Produces a click event handler that removes a particular hotel request
  remHotel: index => evt => {
      evt.preventDefault()
      onRequestChange(request.deleteIn(['required', index]))
  },

  // Produces a click hander that adds a hotel request. Delegates pre-population to
  // separate function
  addHotel: evt => {
      evt.preventDefault()
      onRequestChange(request.updateIn(['required'], (r=List()) => r.push(Map.of('isA', 'HotelRequirement'))))
  },

  // Produces a react-bootstrap-date-picker onChange handler to accept
  // the new check in date
  checkinDateChange: index => isoDate => {
    console.log("new date: " + isoDate)
    request = request.setIn(
        ['required', index, 'checkIn'],
        moment(isoDate).format("YYYY-MM-DD")
    )
    if (moment(isoDate).isAfter(moment(request.getIn(['required', index, 'checkOut'], moment().format()))))
    {
      request = request.setIn(
          ['required', index, 'checkOut'],
          moment(isoDate).add(1,'days').format("YYYY-MM-DD")
      )
    }

    onRequestChange(request)
  },

  // Produces a react-bootstrap-date-picker onChange handler to accept
  // the new check out date
  checkoutDateChange: index => isoDate => {
    console.log("new date: " + isoDate)
    onRequestChange(request.setIn(
        ['required', index, 'checkOut'],
        moment(isoDate).format("YYYY-MM-DD")
    ))
  },

  // Produces a text field change handler that changes location
  locationChange: index => location => {
    console.log(location.toString())
    onRequestChange(request
      .setIn(['required', index, "approximateLocation", "geoLocation"], location.get("gpsLocation"))
      .setIn(['required', index, "approximateLocation", "address", "namedAddress"], location.get("name"))
    )
  },

  // Produces a dropdown menu change handler that changes number of rooms
  numOfRoomsChange: index => numberOfRooms =>
  {
    onRequestChange(request.setIn(['required',index,'totalUnitsRequired'], numberOfRooms.target.value))
  }

})

export default withProps(fineGrainedEditCallbacks)(AccommodationRequirementEditor)



// WEBPACK FOOTER //
// ./src/ndc/request/AccommodationRequirementEditor.js